export enum enumMarineInsurancePendingPaymentAction {
  ADDITIONAL_PAYMENT = 1,
  REFUND_PAYMENT = 2,
}
